var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import AnalysisStudyListConstants from "./AnalysisStudyListConstants.js";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus, ApiErrorType } from "@ane/core/lib/models";
import { loadExperimentStepPlanSummaryEpicReducer } from "../epics/AnalysisStudyListEpic.js";
import { findV2StudyAbstractFromStore, AbstractLocation } from "../utils/AnalysisStudyUtils.js";
import ___default from "lodash";
const getDefaultState = () => {
  return {
    showForayAppParameters: false,
    routeContext: {
      stepId: null,
      viewStudyId: null,
      viewTaskId: null
    },
    v2StudyAbstractsByStepId: {},
    v2StudyEachAbstractByStepAndStudyId: {},
    rawStudyByStudyId: {},
    v2TaskLogEntriesByTaskId: {},
    studyAbstracts: {
      isLoading: false,
      error: null,
      data: null
    },
    studies: {},
    studyIsUpdating: {},
    isLoadingStudies: false,
    forayConfigMetadata: { isLoading: false, data: null, error: null },
    analysisStepProperties: { isLoading: false, data: null, error: null },
    experimentStepPlanSummaryAsync: getDefaultAsyncWrapperObj(),
    taskOverviewInfoForScorecardId: { isLoading: false, data: null, error: null },
    registerAnalysisAsync: getDefaultAsyncWrapperObj(),
    workspaceSplitRedirect: getDefaultAsyncWrapperObj()
  };
};
const setRouteContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    routeContext: actionResult.payload
  });
};
const loadingStudyAbstractsForStep = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    studyAbstracts: { isLoading: true, data: null, error: null },
    isLoadingStudies: true
  });
};
const loadedStudyAbstractsForStepId = (state, actionResult) => {
  const payload = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    studyAbstracts: { isLoading: false, data: payload.studyAbstracts, error: null }
  });
};
const loadedStudiesForStepId = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    isLoadingStudies: false
  });
};
const loadingStudy = (state, actionResult) => {
  const payload = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    studies: __spreadProps(__spreadValues({}, state.studies), { [payload]: { isLoading: true, data: null, error: null } })
  });
};
const loadedStudy = (state, actionResult) => {
  const payload = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    studies: __spreadProps(__spreadValues({}, state.studies), { [payload.studyId]: { isLoading: false, data: payload.studyData, error: null } })
  });
};
const registeringAnalysis = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    registerAnalysisAsync: __spreadProps(__spreadValues({}, state.registerAnalysisAsync), {
      status: AsyncRequestStatus.Pending
    })
  });
};
const registeredAnalysis = (state, registerAnalysisAsync) => {
  return __spreadProps(__spreadValues({}, state), {
    registerAnalysisAsync
  });
};
const loadingV2StudyAbstractsForStepId = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    v2StudyAbstractsByStepId: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId), {
      [actionResult.payload]: { data: null, error: null, isLoading: true }
    })
  });
};
const loadedV2StudyAbstractsForStepIdLegacy = (state, actionResult) => {
  const { stepId, v2StudyAbstracts } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    v2StudyAbstractsByStepId: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId), {
      [stepId]: { data: v2StudyAbstracts, error: null, isLoading: false }
    })
  });
};
const loadedV2StudyAbstractsForStepId = (state, actionResult) => {
  const { stepId, request } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    v2StudyAbstractsByStepId: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId), {
      [stepId]: __spreadValues({}, request)
    })
  });
};
const loadingV2TaskLogsForTaskId = (state, actionResult) => {
  const { taskId } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    v2TaskLogEntriesByTaskId: __spreadProps(__spreadValues({}, state.v2TaskLogEntriesByTaskId), {
      [taskId]: { data: null, error: null, isLoading: true }
    })
  });
};
const loadedV2TaskLogsForTaskId = (state, actionResult) => {
  const { taskId, v2TaskLogEntries } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    v2TaskLogEntriesByTaskId: __spreadProps(__spreadValues({}, state.v2TaskLogEntriesByTaskId), {
      [taskId]: { data: v2TaskLogEntries, error: null, isLoading: false }
    })
  });
};
const loadingTaskOverviewInfoForScorecardId = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    taskOverviewInfoForScorecardId: { data: null, error: null, isLoading: true }
  });
};
const loadedTaskOverviewInfoForScorecardId = (state, actionResult) => {
  const { taskOverviewInfo, error } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    taskOverviewInfoForScorecardId: {
      data: !!taskOverviewInfo ? taskOverviewInfo : null,
      error: !!error ? error : null,
      isLoading: false
    }
  });
};
const setResultForStepAndStudyId = (state, payload, requestResult) => {
  const { stepId, studyId } = payload || {};
  const forStepId = state.v2StudyEachAbstractByStepAndStudyId[stepId];
  const newForStepId = __spreadProps(__spreadValues({}, forStepId), {
    [studyId]: requestResult
  });
  return __spreadProps(__spreadValues({}, state), {
    v2StudyEachAbstractByStepAndStudyId: __spreadProps(__spreadValues({}, state.v2StudyEachAbstractByStepAndStudyId), {
      [stepId]: newForStepId
    })
  });
};
const loadingV2StudyAbstract = (state, actionResult) => {
  return setResultForStepAndStudyId(state, actionResult.payload, { data: null, error: null, status: AsyncRequestStatus.Pending });
};
const loadedV2StudyAbstract = (state, actionResult) => {
  var _a, _b, _c, _d, _e, _f;
  if (!((_b = (_a = actionResult == null ? void 0 : actionResult.payload) == null ? void 0 : _a.result) == null ? void 0 : _b.data)) {
    return setResultForStepAndStudyId(state, (_c = actionResult.payload) == null ? void 0 : _c.params, {
      data: null,
      error: "Study failed to load",
      status: AsyncRequestStatus.Failed
    });
  }
  return setResultForStepAndStudyId(state, (_d = actionResult.payload) == null ? void 0 : _d.params, {
    data: (_f = (_e = actionResult.payload) == null ? void 0 : _e.result) == null ? void 0 : _f.data,
    error: null,
    status: AsyncRequestStatus.Completed
  });
};
const loadedWorkspaceSplitRedirect = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    workspaceSplitRedirect: {
      errorContext: { statusCode: 301, displayError: "", type: ApiErrorType.MovedPermanently, correlationId: "" },
      data: { workspaceId: actionResult.payload.workspaceRedirect.data.workspaceId },
      status: AsyncRequestStatus.Completed
    }
  });
};
const loadingForayConfigMetadata = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    forayConfigMetadata: { isLoading: true, data: null, error: null }
  });
};
const loadedForayConfigMetadata = (state, actionResult) => {
  const payload = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    forayConfigMetadata: { isLoading: false, data: payload, error: null }
  });
};
const loadingAnalysisStepProperties = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    analysisStepProperties: { isLoading: true, data: null, error: null }
  });
};
const loadedAnalysisStepPropertiesLegacy = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    analysisStepProperties: { isLoading: false, data: actionResult.payload, error: null }
  });
};
const loadedAnalysisStepProperties = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    analysisStepProperties: __spreadValues({}, actionResult.payload)
  });
};
const updatingStudy = (state, actionResult) => {
  const payload = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    studyIsUpdating: __spreadProps(__spreadValues({}, state.studyIsUpdating), { [payload.studyId]: true })
  });
};
const setStudyState = (state, actionResult, setActive) => {
  const { stepId, studyId } = actionResult.payload;
  if (studyId) {
    const updatedAbstract = findV2StudyAbstractFromStore(state, stepId, studyId);
    if (updatedAbstract.abstractLocation === AbstractLocation.v2StudyAbstractsByStepId) {
      return setStudyStateV2StudyAbstractsByStepId(state, actionResult, setActive);
    } else {
      return setStudyStateV2StudyEachAbstractByStepAndStudyId(state, actionResult, setActive);
    }
  } else {
    return __spreadValues({}, state);
  }
};
const setStudyStateV2StudyAbstractsByStepId = (state, actionResult, setActive) => {
  const { stepId, studyId } = actionResult.payload;
  const studyIsUpdating = __spreadProps(__spreadValues({}, state.studyIsUpdating), { [studyId]: false });
  const abstractListForStepId = ___default.map(state.v2StudyAbstractsByStepId[stepId].data, (abstract) => {
    if (abstract.StudyId === studyId) {
      return __spreadProps(__spreadValues({}, abstract), { IsActive: setActive });
    } else {
      return abstract;
    }
  });
  return __spreadProps(__spreadValues({}, state), {
    v2StudyAbstractsByStepId: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId), {
      [stepId]: { data: abstractListForStepId, isLoading: false, error: null }
    }),
    studyIsUpdating
  });
};
const setStudyStateV2StudyEachAbstractByStepAndStudyId = (state, actionResult, setActive) => {
  const { stepId, studyId } = actionResult.payload;
  const studyIsUpdating = __spreadProps(__spreadValues({}, state.studyIsUpdating), { [studyId]: false });
  const v2StudyEachAbstractForStepId = state.v2StudyEachAbstractByStepAndStudyId[stepId];
  const v2StudyEachAbstractForStepAndStudyId = v2StudyEachAbstractForStepId[studyId];
  return __spreadProps(__spreadValues({}, state), {
    v2StudyEachAbstractByStepAndStudyId: __spreadProps(__spreadValues({}, state.v2StudyEachAbstractByStepAndStudyId), {
      [stepId]: __spreadProps(__spreadValues({}, v2StudyEachAbstractForStepId), {
        [studyId]: __spreadProps(__spreadValues({}, v2StudyEachAbstractForStepAndStudyId), {
          data: __spreadProps(__spreadValues({}, v2StudyEachAbstractForStepAndStudyId.data), { IsActive: setActive })
        })
      })
    }),
    studyIsUpdating
  });
};
const setStudyDeleted = (state, actionResult) => {
  const { stepId, studyId } = actionResult.payload;
  if (studyId) {
    const updatedAbstract = findV2StudyAbstractFromStore(state, stepId, studyId);
    if (updatedAbstract.abstractLocation === AbstractLocation.v2StudyAbstractsByStepId) {
      return __spreadProps(__spreadValues({}, state), {
        v2StudyAbstractsByStepId: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId), {
          [stepId]: __spreadProps(__spreadValues({}, state.v2StudyAbstractsByStepId[stepId]), {
            data: ___default.filter(state.v2StudyAbstractsByStepId[stepId].data, (a) => a.StudyId !== studyId)
          })
        })
      });
    } else {
      const _a = state.v2StudyEachAbstractByStepAndStudyId[stepId], { [studyId]: value } = _a, withoutStudy = __objRest(_a, [__restKey(studyId)]);
      return __spreadProps(__spreadValues({}, state), {
        v2StudyEachAbstractByStepAndStudyId: __spreadProps(__spreadValues({}, state.v2StudyEachAbstractByStepAndStudyId), {
          [stepId]: withoutStudy
        })
      });
    }
  } else {
    return __spreadValues({}, state);
  }
};
const AnalysisStudyListReducer = (state = getDefaultState(), actionResult) => {
  state = loadExperimentStepPlanSummaryEpicReducer.reduxChange(state, actionResult);
  switch (actionResult.type) {
    case AnalysisStudyListConstants.SET_ROUTE_CONTEXT:
      return setRouteContext(state, actionResult);
    case AnalysisStudyListConstants.LOADED_STUDIES_FOR_STEP_ID:
      return loadedStudiesForStepId(state);
    case AnalysisStudyListConstants.LOADING_STUDY_ABSTRACTS_FOR_STEP_ID:
      return loadingStudyAbstractsForStep(state);
    case AnalysisStudyListConstants.REGISTERING_ANALYSIS_FOR_STEP:
      return registeringAnalysis(state);
    case AnalysisStudyListConstants.REGISTERED_ANALYSIS_FOR_STEP:
      return registeredAnalysis(state, actionResult.payload.registerAnalysisAsync);
    case AnalysisStudyListConstants.LOADED_STUDY_ABSTRACTS_FOR_STEP_ID:
      return loadedStudyAbstractsForStepId(state, actionResult);
    case AnalysisStudyListConstants.LOADING_STUDY:
      return loadingStudy(state, actionResult);
    case AnalysisStudyListConstants.LOADED_STUDY:
      return loadedStudy(state, actionResult);
    case AnalysisStudyListConstants.LOADING_FORAY_CONFIG_METADATA:
      return loadingForayConfigMetadata(state);
    case AnalysisStudyListConstants.LOADED_FORAY_CONFIG_METADATA:
      return loadedForayConfigMetadata(state, actionResult);
    case AnalysisStudyListConstants.LOADING_ANALYSIS_STEP_PROPERTIES:
      return loadingAnalysisStepProperties(state);
    case AnalysisStudyListConstants.LOADED_ANALYSIS_STEP_PROPERTIES_LEGACY:
      return loadedAnalysisStepPropertiesLegacy(state, actionResult);
    case AnalysisStudyListConstants.LOADED_ANALYSIS_STEP_PROPERTIES:
      return loadedAnalysisStepProperties(state, actionResult);
    case AnalysisStudyListConstants.STUDY_STATE_UPDATING:
      return updatingStudy(state, actionResult);
    case AnalysisStudyListConstants.SET_STUDY_ENABLED:
      return setStudyState(state, actionResult, true);
    case AnalysisStudyListConstants.SET_STUDY_DISABLED:
      return setStudyState(state, actionResult, false);
    case AnalysisStudyListConstants.SET_STUDY_DELETED:
      return setStudyDeleted(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADING_STUDY_ABSTRACTS_FOR_STEP_ID:
      return loadingV2StudyAbstractsForStepId(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID_LEGACY:
      return loadedV2StudyAbstractsForStepIdLegacy(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID:
      return loadedV2StudyAbstractsForStepId(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADING_STUDY_ABSTRACT:
      return loadingV2StudyAbstract(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACT:
      return loadedV2StudyAbstract(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADING_TASK_LOGS:
      return loadingV2TaskLogsForTaskId(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADED_TASK_LOGS:
      return loadedV2TaskLogsForTaskId(state, actionResult);
    case AnalysisStudyListConstants.LOADING_TASK_OVERVIEW_INFO_FOR_SCORECARDID:
      return loadingTaskOverviewInfoForScorecardId(state);
    case AnalysisStudyListConstants.LOADED_TASK_OVERVIEW_INFO_FOR_SCORECARDID:
      return loadedTaskOverviewInfoForScorecardId(state, actionResult);
    case AnalysisStudyListConstants.V2_LOADED_WORKSPACE_REDIRECT:
      return loadedWorkspaceSplitRedirect(state, actionResult);
    case AnalysisStudyListConstants.LOADING_RAW_STUDY:
      return __spreadProps(__spreadValues({}, state), {
        rawStudyByStudyId: __spreadProps(__spreadValues({}, state.rawStudyByStudyId), {
          [actionResult.payload.studyId]: {
            data: null,
            status: AsyncRequestStatus.Pending,
            error: ""
          }
        })
      });
    case AnalysisStudyListConstants.LOADED_RAW_STUDY:
      return __spreadProps(__spreadValues({}, state), {
        rawStudyByStudyId: __spreadProps(__spreadValues({}, state.rawStudyByStudyId), {
          [actionResult.payload.studyId]: actionResult.payload.rawStudy
        })
      });
    case AnalysisStudyListConstants.TOGGLE_SHOW_FORAY_PARAMETER:
      return __spreadProps(__spreadValues({}, state), {
        showForayAppParameters: actionResult.payload.showForayParameters
      });
    default:
      return state;
  }
};
export {
  AnalysisStudyListReducer,
  AnalysisStudyListReducer as default,
  getDefaultState
};
//# sourceMappingURL=AnalysisStudyListReducer.js.map
